import React from 'react';
import deviceDOMHoc from '../../hocs/deviceDOMHoc';
import {
  inject,
  observer,
} from 'mobx-react';
import {
  Slider,
  withStyles,
} from '@material-ui/core';
import { useStores } from '../../hooks/use-stores';
import { DeviceStatusLabel } from './components/labels';

const AnalogSlider = withStyles({
  root: {
    color: '#95a9b5',
    height: 10,
  },
  thumb: {
    backgroundColor: '#01cc87',
    border: '2px solid #119d6d',
    height: '24px',
    width: '24px',
    marginTop: '-8px',
    marginLeft: '-12px',
    '&:focus,&:hover,&$active': {
      boxShadow: 'inherit',
    },
  },
  active: {},
  valueLabel: {
    left: 'calc(-50% + 4px)',
    fontSize: '16px',
  },
  mark: {
    height: 10,
    width: 1,
  },
  markLabel: {
    fontSize: '14px',
    color: 'currentColor',
    marginTop: 5,
  },
  track: {
    height: 10,
  },
  rail: {
    backgroundColor: '#b0c6d1',
    height: 10,
  },
})(Slider);

function AnalogSwitch(props) {
  const { device } = props;
  const { batchStore } = useStores();
  const deviceStatus = batchStore.getDeviceStatus(device.id);
  const marks = Array.isArray(device.rampUps) ? device.rampUps.map(v => {return {value: v.value, label: v.value};}) : [];

  return (
    <div id={`device-${device.id}`} className={'device-gui device-gui--analog-switch'}>
      <DeviceStatusLabel
        name={device.description}
        status={`${batchStore.analogOutputs[device.channelPNo - 1] || 0}%`}
        title={`#${device.id}`}
      />
      <div className={'slider-wrap'}>
        <AnalogSlider
          defaultValue={Number(batchStore.analogOutputs[device.channelPNo - 1]) || 0}
          value={deviceStatus.target}
          min={0}
          max={100}
          marks={marks}
          aria-labelledby="slider"
          step={device.divisions || 5}
          valueLabelDisplay="auto"
          onChangeCommitted={(e, value) => {
            e.stopPropagation();
            if (device.channelPNo) {
              batchStore.setAnalog(device.channelPNo, value);
            }
          }}
          onChange={(e, value) => {
            e.stopPropagation();
            batchStore.deviceStatus.set(device.id, {
              ...deviceStatus,
              target: value,
            });
          }}
        />
      </div>
    </div>
  );
}

export default deviceDOMHoc(inject('batchStore')(observer(AnalogSwitch)));
